'use client';

import { useMemo, useState } from 'react';

import { FAQ_DATA } from '../constants';
import { Accordion } from './Accordion';

export const FAQSection = () => {
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  const faqSchema = useMemo(() => {
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: FAQ_DATA.flatMap((category) =>
        category.items.map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      ),
    };

    return (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      />
    );
  }, []);

  const handleToggle = (itemId: string) => {
    setOpenItemId((prev) => (prev === itemId ? null : itemId));
  };

  return (
    <>
      {faqSchema}
      <section
        className="w-full bg-Gray-900 p-32 md:py-60"
        aria-labelledby="faq-heading"
      >
        <div className="flex w-full flex-col gap-16 pb-80 md:gap-24">
          <h2 id="faq-heading" className="m-0 font-800 text-Gray-white typo-h4">
            FAQ
          </h2>
          <div className="flex w-full flex-col gap-32">
            {FAQ_DATA.map((category) => (
              <section
                key={category.id}
                className="flex w-full flex-col"
                aria-labelledby={`faq-category-${category.id}`}
              >
                <h3
                  id={`faq-category-${category.id}`}
                  className="m-0 w-full border-b border-Gray-550 pb-12 font-700 text-Gray-white typo-body3"
                >
                  {category.title}
                </h3>
                <div className="flex w-full flex-col px-8 py-4">
                  {category.items.map((item) => (
                    <Accordion
                      key={item.id}
                      item={item}
                      isOpen={openItemId === item.id}
                      onToggle={() => handleToggle(item.id)}
                    />
                  ))}
                </div>
              </section>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};
